import { render, staticRenderFns } from "./MagazzinoArticoliGiacenzaCodiciComponent.vue?vue&type=template&id=3d0ee49c&scoped=true"
import script from "./MagazzinoArticoliGiacenzaCodiciComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliGiacenzaCodiciComponent.vue?vue&type=script&lang=js"
import style0 from "./MagazzinoArticoliGiacenzaCodiciComponent.vue?vue&type=style&index=0&id=3d0ee49c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0ee49c",
  null
  
)

export default component.exports